import {Injectable} from '@angular/core';
import {BaseService} from '../base/base.service';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {UploadedFileInfo} from '../../models/ui/uploaded-file-info.class';
import {AppModulePath} from '../../models/app-module-path';
import {HttpResponse} from '@angular/common/http';
import {Status, WebMethodResult} from '../../models/web-method-result';


@Injectable()
export class FilePreviewService extends BaseService {

  private listUrl = '/api/files/list';
  private uploadUrl = '/api/files/upload';
  private getUrl = '/api/files/get';
  private removeUrl = '/api/files/remove';
  private pathForEntityUrl = '/api/files/path_for_entity';

  public list(path: string, appModule: string): Observable<UploadedFileInfo[]> {
    return this.get<UploadedFileInfo[]>(this.listUrl + `?path=${encodeURIComponent(path)}`, appModule).pipe(
        map(flist => flist.map(file => new UploadedFileInfo(file))),
        catchError(this.handleError)
    );
  }

  public upload(path: string, file: File, appModule: string): Observable<UploadedFileInfo> {
    const fd: FormData = new FormData();
    fd.append('path', path);
    fd.append('file', file);
    if (appModule === 'Company') {
      fd.append('fileName', 'logo.png');
    }
    return this.post<UploadedFileInfo>(this.uploadUrl, appModule, fd).pipe(
        map(res => new UploadedFileInfo(res)),
        catchError(this.handleError)
    )
  }

  public getFile(info: UploadedFileInfo, appModule: string): Observable<UploadedFileInfo> {
    //console.log('Pozivam getFile URL:', this.getUrl + `?path=${encodeURIComponent(info.path)}`);

    return this.get<HttpResponse<Blob>>(this.getUrl + `?path=${encodeURIComponent(info.path)}`, appModule,
        {observe: 'response', responseType: 'blob'}).pipe(
        map((resp: HttpResponse<Blob>) => {
          info.data = new Blob([resp.body], { type: info.mimeType });
          info.url = URL.createObjectURL(info.data);
          info.safeUrl = this.sanitizerSvc.bypassSecurityTrustResourceUrl(info.url);
          return info;
        }),
    )
  }

  public remove(path: string, appModule: string): Observable<any> {
    return this._delete<any>(this.removeUrl + `?path=${encodeURIComponent(path)}`, appModule).pipe(
        catchError(this.handleError)
    );
  }

  public pathForEntity(_entityClass: string, _entityId: string, appModule: string): Observable<string> {
    return this.get<HttpResponse<string>>(`${this.pathForEntityUrl}?entityClass=${encodeURIComponent(_entityClass)}&entityId=${_entityId}`,
        appModule, {observe: 'response', responseType: 'text'}).pipe(
      map((resp: HttpResponse<string>) => resp.body),
      catchError(this.handleError));
  }
}
